import {Component, Inject, OnInit} from '@angular/core';
import {UserService} from '../../../shared/user.service';
import {CookieService} from 'ngx-cookie';
import * as moment from 'moment';
import * as angular from 'angular';
import {NotificationsService} from '../notifications.service';
import {LOCATION_SERVICE} from '../../../shared/upgrade/location.service';


interface TimecardCookieData {
	paymentFrequency: 'monthly' | 'bi-weekly';
	employees: number[];
	startDate: string;
	endDate: string;
	user: string;
}

@Component({
	selector: 'tt-unapproved-timecards-notification',
	templateUrl: './unapproved-timecards.component.html',
	styleUrls: ['./unapproved-timecards.component.scss']
})
export class UnapprovedTimecardsNotificationComponent implements OnInit {

	private cookieName: string = 'timecardsState';

	data: any[] = [];

	private initialized: boolean = false;

	constructor(private userService: UserService,
				private cookieService: CookieService,
				private notificationsService: NotificationsService,
				@Inject('$rootScope') private rootScopeService: angular.IRootScopeService,
				@Inject(LOCATION_SERVICE) private locationService: angular.ILocationService) {
	}

	ngOnInit(): void {
		this.loadMissingWorkingDays();

		this.rootScopeService.$on('userDetailsLoaded',
			() => this.loadMissingWorkingDays());
	}

	loadMissingWorkingDays(): void {
		if (this.initialized) {
			return;
		}

		if (this.userService.user && this.userService.user.ttAdmin) {
			this.initialized = true;
			this.notificationsService
				.getTimeCardsWaitingForApproval()
				.subscribe((data: any[]) => this.data = data);
		}
	}

	goToTimeCard(timeCard: any): void {
		const data: TimecardCookieData = {
			paymentFrequency: this.getTimecardPaymentFrequency(timeCard),
			employees: [timeCard.employeeId],
			startDate: timeCard.startDate,
			endDate: timeCard.endDate,
			user: this.userService.user.loginName
		};

		this.cookieService.putObject(this.cookieName, data, {
			expires: moment().add(90, 'days').toDate()
		});

		this.cookieService.putObject('selectedTimecardsEmployeesNG2', { employees: data.employees }, {
			expires: moment().add(90, 'days').toDate()
		});

		this.locationService.path('/timecardsReportNew');
	};

	getTimecardPaymentFrequency(timeCard: any): 'monthly' | 'bi-weekly'  {
		const start: string[] = timeCard.startDate.split('/');
		const end: string[] = timeCard.endDate.split('/');

		if (start[1] === '01' && parseInt(end[1], 10) > 27) {
			return 'monthly';
		} else {
			return 'bi-weekly';
		}
	}


}



// WEBPACK FOOTER //
// ./src/app/my-time/notifications/unapproved-timecards/unapproved-timecards.component.ts